import { NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { pageTransitions } from '../../../../animations/page-transitions';
import { DocumentOrderNumberFilter, DynamicDatacenterFilter } from '../../../../models/datacenter-filters';

@Component({
	selector: 'copo-document-order-number-filter',
	templateUrl: './document-order-number-filter.component.html',
	styleUrl: './document-order-number-filter.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		NgFor,
		MatIconModule,
		MatRippleModule,
		MatFormFieldModule,
		MatInputModule,
		FormsModule,
		MatButtonModule,
	]
})
export class DocumentOrderNumberFilterComponent implements DynamicDatacenterFilter<DocumentOrderNumberFilter> {
	@Input() filter?: DocumentOrderNumberFilter;
	@Output() readonly removeFilter = new EventEmitter<void>();
	@Input() isDefaultFilter?: boolean;

	removeValue(index: number) {
		if (!this.filter) {
			return;
		}
		this.filter.getValues().splice(index, 1);
		if (!this.filter.valueSize()) {
			this.removeFilter.emit();
		}
	}

	trackByFunc(index: number) {
		return index;
	}

	getPreparedFilterValues() {
		if (this.filter) {
			return {
				id: this.filter.filterId,
				values: this.filter.getValues()
					.filter(filterValue => filterValue.reference || filterValue.item)
			};
		}
		return undefined;
	}
}
